import { jsx as _jsx } from "react/jsx-runtime";
import { Card as HeroCard, CardHeader as HeroCardHeader, CardBody as HeroCardBody, CardFooter as HeroCardFooter } from '@heroui/react';
export const Card = (props) => {
    return _jsx(HeroCard, { ...props });
};
export const CardHeader = (props) => {
    return _jsx(HeroCardHeader, { ...props });
};
export const CardBody = (props) => {
    return _jsx(HeroCardBody, { ...props });
};
export const CardFooter = (props) => {
    return _jsx(HeroCardFooter, { ...props });
};
export default Card;
//# sourceMappingURL=Card.js.map